import React, { useEffect } from 'react';
import { PortalNavbar } from '../components/portal/PortalNavbar';
import { PortalHero } from '../components/portal/PortalHero';
import { PortalHowItWorks } from '../components/portal/PortalHowItWorks';
import { PortalPaymentOptions } from '../components/portal/PortalPaymentOptions';
import { PortalFAQ } from '../components/portal/PortalFAQ';
import { PortalContact } from '../components/portal/PortalContact';
import { PortalFooter } from '../components/portal/PortalFooter';
import { useScreenInit } from '../useScreenInit';
export function PortalHome() {
  useScreenInit();
  // Scroll to top on mount since it's a new page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-brand-red/20 selection:text-brand-navy flex flex-col" data-id="element-1450">
      <PortalNavbar data-id="element-1451" />
      <main className="flex-grow" data-id="element-1452">
        <PortalHero data-id="element-1453" />
        <PortalHowItWorks data-id="element-1454" />
        <PortalPaymentOptions data-id="element-1455" />
        <PortalFAQ data-id="element-1456" />
        <PortalContact data-id="element-1457" />
      </main>
      <PortalFooter data-id="element-1458" />
    </div>;
}